import { SERVICE_URL } from './ServiceURL'

class BilhetagemService {
	constructor(resource) {
		this.store = resource.$store;
		this.http = resource.$http;

		this.baseURL = `${SERVICE_URL}v1/projetos/bilhetagem`;
	}

	save(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.baseURL, data, {
				headers: {
					'x-access-token': this.store.state.user.token || ''
				}
			})
		})
	}
}

export default BilhetagemService


// WEBPACK FOOTER //
// ./src/service/BilhetagemService.js